/**
 * Hình thức cấp phát (Hạch toán đồng thời)
 */
export default {
  // / dự toán
  Estimate: 1,

  // / lệnh chi tiền
  Payment: 2,
};
